export default __webpack_public_path__ + "static/media/pgmico(7).86cb8f7b.png";